import { WellKnownTextString } from "../geom";
import { isString } from "../utils/utils";

const wktPattern = /^(POINT|LINESTRING|POLYGON|MULTIPOINT|MULTILINESTRING|MULTIPOLYGON|GEOMETRYCOLLECTION)\s*(\(.*\)|EMPTY)$/i;


export function isWellKnownText(arg: any): arg is WellKnownTextString {

    if (isString(arg)) {
        return wktPattern.test(arg)
    }

}

const wellKnownTextPolygonPrefix = new RegExp("^POLYGON\\s*\\(\\(", "i")

export function isWellKnownTextPolygon(arg: any): arg is WellKnownTextString {
    return isString(arg) && wellKnownTextPolygonPrefix.test(arg)
}